import { Component, OnInit, Input } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-afleveradressenlist',
  templateUrl: './afleveradressenlist.component.html',
  styleUrls: ['./afleveradressenlist.component.less']
})
export class AfleveradressenlistComponent implements OnInit {


  @Input() relatieid : number;
  adressen: any =null;

  constructor(private source: RelatiesService) { }

  ngOnInit() {
     this.source.getAfleveradressen(this.relatieid).subscribe(data => {
       this.adressen = data;
     })
  }

  addNew() {
    let relatieid = this.relatieid;
    this.source.addAfleveradressen(this.relatieid).subscribe(data => {
      this.adressen.push({
          ID : data.ID,
          BedrijfNummer : relatieid,
          AdresRegel1 : '',
          AdresRegel2 : '',
          AdresRegel3 : '',
          AdresRegel4 : '',
          isDefault : false
      })
  })
  }

  deleted(id: number) {
    this.adressen.forEach( (item, index) => {
        if(item.ID === id) {
          this.adressen.splice(index,1);
        }
    });
  }

}
